/**
 * T2333 — identiteta ZAVIHKA (ne uporabnika), ustvarjena enkrat ob nalaganju.
 *
 * Odmev lastne spremembe po WebSocketu je treba prepoznati po zavihku: isti
 * uporabnik v drugem zavihku mora osvežitev dobiti, sicer bi tam gledal staro
 * stanje. Pošilja se kot glava `X-Client-Id` (REST) in kot `client_id` v
 * naslovu projektnega WebSocketa; zaledje jo vrne v `origin_client_id`.
 */
function generate(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // nevaren kontekst (http) — spodnja rezerva
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export const CLIENT_ID: string = generate();
